import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { useEventCallback } from '../../hooks/useEventCallback';
import { IconDeprecated, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { SidebarWithBackdrop } from '../SidebarWithBackdrop/SidebarWithBackdrop';
import styles from './NavigationSidebar.module.css';
export type NavigationItem = {
  iconName: string;
  iconType: IconType;
  label: string;
  to: NavLinkProps['to'];
};
export type NavigationSidebarProps = {
  navigationItems: Array<NavigationItem>;
  opened: boolean;
  /**
   * this is called when something occured which wants to close the sidebar
   */
  onCloseSidebar: () => void;
  onLogoutClick: () => void;
  onOpenUserProfile: () => void;
  'data-testid'?: string;
};
export const NavigationSidebar: FunctionComponent<NavigationSidebarProps> = React.memo(props => {
  const $ = _c(29);
  const {
    navigationItems,
    opened,
    "data-testid": testid,
    onCloseSidebar,
    onLogoutClick,
    onOpenUserProfile
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const {
    t
  } = useTranslation("record-it-components");
  const handleOpenUserProfileClick = useEventCallback(() => {
    onCloseSidebar();
    onOpenUserProfile();
  });
  const T0 = SidebarWithBackdrop;
  const t0 = styles;
  const t1 = navigationItems.map((item, index) => <NavLink to={item.to} key={index} className={styles.navItem} onClick={onCloseSidebar} data-testid="NavigationSidebar.NavItem"><IconDeprecated name={item.iconName} type={item.iconType} className={styles.navItemIcon} /><span className={styles.navItemText}>{item.label}</span></NavLink>);
  let t2;
  if ($[0] !== t0.navItemsWrapper || $[1] !== t1) {
    t2 = <div className={t0.navItemsWrapper}>{t1}</div>;
    $[0] = t0.navItemsWrapper;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconDeprecated name="user-circle" type={IconType.Regular} hasTextOnRightSide={true} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("pageLayout.NavigationSidebar.userProfile");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <span className={styles.navItemText}>{t4}</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== handleOpenUserProfileClick || $[9] !== t5) {
    t6 = <button type="button" className={styles.navItem} onClick={handleOpenUserProfileClick} data-testid="NavigationSidebar.UserProfileButton">{t3}{t5}</button>;
    $[8] = handleOpenUserProfileClick;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <IconDeprecated name="sign-out" type={IconType.Regular} hasTextOnRightSide={true} />;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("pageLayout.NavigationSidebar.logout");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <span className={styles.navItemText}>{t8}</span>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== onLogoutClick || $[17] !== t9) {
    t10 = <button type="button" className={styles.navItem} onClick={onLogoutClick} data-testid="NavigationSidebar.LogoutButton">{t7}{t9}</button>;
    $[16] = onLogoutClick;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t6) {
    t11 = <div className={styles.bottomSection}>{t6}{t10}</div>;
    $[19] = t10;
    $[20] = t6;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== T0 || $[23] !== onCloseSidebar || $[24] !== opened || $[25] !== t11 || $[26] !== t2 || $[27] !== testid) {
    t12 = <T0 opened={opened} onCloseSidebar={onCloseSidebar} data-testid={testid}>{t2}{t11}</T0>;
    $[22] = T0;
    $[23] = onCloseSidebar;
    $[24] = opened;
    $[25] = t11;
    $[26] = t2;
    $[27] = testid;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
});